import { A11y } from "swiper/modules";

class ProductFeatures extends window.BAO.CustomElement() {
  
  connectedCallback () {
    super.connectedCallback()

    this.initCarousel()
  }
  
  initCarousel() {
    this.carouselEl = this.getCarouselEl();
    if (this.carouselEl) {
      new window.swiper(this.carouselEl, {
        
        spaceBetween: 5,
        slidesPerView: 1.2,
        loop: false,
        slidesOffsetAfter: 20,
        breakpoints: {
          992: {
            slidesOffsetAfter: 0,
            slidesPerView: 3,
          }
        },
        navigation: {
          nextEl: '[data-product-features-el="next"]',
          prevEl: '[data-product-features-el="prev"]',
        },
        on: {
          init: this.updateNavAria,
          slideChange: this.updateNavAria,
          reachBeginning: this.updateNavAria,
          reachEnd: this.updateNavAria,
          fromEdge: this.updateNavAria,
        }
      });
    }
  }

  updateNavAria(swiper) {
    [swiper.navigation.prevEl, swiper.navigation.nextEl].forEach((el) => {
      const disabled = el?.classList.contains('swiper-button-disabled');

      el?.setAttribute('aria-hidden', disabled ? 'true' : 'false');
    });
  }

  getCarouselEl () {
    return window.BAO.Utils.getElement(this.els.swiper.selector, {
      context: this,
    })
  }
}

if (!customElements.get('product-features')) {
  customElements.define('product-features', ProductFeatures)
}
